import { render, staticRenderFns } from "./TransactionDetailHeader.vue?vue&type=template&id=4f57ed6c&"
import script from "./TransactionDetailHeader.vue?vue&type=script&lang=js&"
export * from "./TransactionDetailHeader.vue?vue&type=script&lang=js&"
import style0 from "./TransactionDetailHeader.vue?vue&type=style&index=0&id=4f57ed6c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports